<template>
  <b-form-select v-model="modelValue" :options="options" :state="state" />
</template>

<script>
import { mapActions } from "vuex";
import { map } from "lodash";
import { modelValue } from "@/mixins/modelValue";

export default {
  mixins: [modelValue("value", "change")],
  data: () => ({
    categorias: [],
  }),
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    state: {
      type: [Boolean, null],
      default: null,
    },
  },
  computed: {
    options() {
      return map(this.categorias, function (obj) {
        return {
          text: obj.nome,
          value: obj.id,
        };
      });
    },
  },
  methods: {
    ...mapActions("perfis", ["ActionGetAllCategories"]),
  },
  async created() {
    try {
      const response = await this.ActionGetAllCategories();
      this.categorias = response.data;
    } catch (error) {}
  },
};
</script>

<style></style>
